<template>
	<div>
		<div class="empty-text" v-if="data.length==0">暂无数据...</div>
		<div class="me-note" v-dt-infinite-scroll="getData">
			<ul class="me-note-items">
				<!--<li class="me-note-item">
					<div class="me-note-title o1">《如何做出良好的设计？？？？？？？？？？》</div>
					<div class="me-note-from o1">源自：第2章·01节土壤对水资源对文化的影响</div>
					<div class="me-note-text o2">如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计如何做出良好的设计</div>
					<div class="me-note-close">×</div>
				</li>-->
				<li class="me-note-item" v-for="(item,index) in data">
					<div class="me-note-title o1" @click="toNote(item.id)">{{item.title}}</div>
					<div class="me-note-from o1" @click="toNote(item.id)">源自：{{item.chapter}}·{{item.section}}土壤对水资源对文化的影响</div>
					<div class="me-note-text o2" v-html="item.content" @click="toNote(item.id)"></div>
				</li>
			</ul>
			<!--<div class="infinite-scroll-text" v-if="!isEnd">加载中</div>-->
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			toNote(id){
				this.$router.push("/note/"+id);
			},
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/note/noteList",
						page,
						len:5,
						user_id:this.$route.params.id,
						user_type:this.tools.getCookie("user_type")
					},res=>{
						var data=res.data;
						this.data=res.data;
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
					})
				})
			}
		},
		created(){
			
		}
	}
</script>

<style>
	.me-note-items{
		padding-top:0.133rem;
	}
	.me-note-item{
		position: relative;
		padding:0.4rem 0;
		margin:0 0.4rem;
		border-bottom:1px solid #e6e6e6;
	}
	.me-note-title{
		width:8.533rem;
		font-size: 0.453rem;
		color:#333;
	}
	.me-note-from{
		margin-top:0.2rem;
		font-size: 0.346rem;
		color:#999;
	}
	.me-note-text{
		margin-top:0.4rem;
		font-size: 0.373rem;
		line-height:0.56rem;
		color:#666;
	}
	.me-note-close{
		position: absolute;
		right:0.1rem;
		top:0.1rem;
		width:1rem;
		height:1rem;
		line-height: 1rem;
		font-size: 0.4rem;
		text-align: center;
		color:#ccc;
	}
	.infinite-scroll-text{
		height:0.533rem;
		line-height: 0.533rem;
		font-size: 0.346rem;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/other-note/other-note.vue